// extracted by mini-css-extract-plugin
module.exports = {"arrow":"CurrencySelect_arrow__5Tbs1"};